import React, {useEffect, useState} from 'react';
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import {getFilterLocation} from "../../microComponents/tablePages/getFilterLocation";
import {getFilterQcStatus} from "../../microComponents/tablePages/getFilterQcStatus";
import FilterSelectOption from "../../microComponents/tablePages/filter/FilterSelectOption";
import DebouncingInputFilter from "../../microComponents/tablePages/filter/DebouncingInputFilter";
import {allowLoadJson} from "../../helper/jsons/activatedJson";
import DateFilter from "../../microComponents/tablePages/filter/DateFilter";


const TopSearchOrder = () => {


    const [filterBranch, setFilterBranch] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);
    const [filterLocation, setFilterLocation] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);
    const [qcStatusList, setQcStatusList] = useState([]);
    const [qcStatusLoading, setQcStatusLoading] = useState(false);

    useEffect(() => {
        getFilterBranch(setFilterBranch, setBranchLoading)
        getFilterLocation(setFilterLocation, setLocationLoading)
        getFilterQcStatus(setQcStatusList, setQcStatusLoading)

    }, [])
    return (<div className='grid grid-cols-1 2xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4   gap-x-4  gap-y-5 mt-10   '>


        <FilterSelectOption data={{
            placeholder: 'واحد',
            filterName: 'branch',
            className: '2md:hidden',

            options: filterBranch,
            loading: branchLoading,

        }}/>


        <FilterSelectOption data={{
            placeholder: 'موقعیت',
            filterName: 'location',
            className: 'lg:hidden',

            options: filterLocation,
            loading: locationLoading,

        }}/>

        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'ق.ت',
                filterName: 'manufacturerPriceRials',

            }}
        />
        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: ' ق.م',
                filterName: 'consumerPriceRials',

            }}
        />


        <DateFilter
            data={{
                className: 'lg:hidden',
                placeholder: ['زمان تولید تا', 'زمان تولید از'],
                filterName: ['fromProduceDate', 'toProduceDate'],
            }}
        />


        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'بچ',

                filterName: 'batchNumber',
            }}
        />

        <FilterSelectOption data={{
            placeholder: 'QC',
            filterName: 'qcStatus',
            className: 'lg:hidden',

            options: qcStatusList,
            loading: qcStatusLoading,

        }}/>
        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'کارشناس QC',

                filterName: 'qualityControlSupervisor',
            }}
        />

        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'سرپرست تولید',

                filterName: 'seriCreateBy',
            }}
        />


        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'شماره حواله',

                filterName: 'orderCode',
            }}
        />

        <FilterSelectOption data={{
            placeholder: 'بارگیری',
            filterName: 'allowLoad',
            className: 'lg:hidden',

            options: allowLoadJson,

        }}/>


    </div>);
};

export default TopSearchOrder;
